module.exports = __webpack_public_path__ + "img/1496980777.208832eb.jpg";